// useI18n.js
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export function useI18n() {
  const { t } = useTranslation();
  return { t };
}

/*
import React from "react";
import { useI18n } from "./useI18n";

function MyComponent() {
  const { t } = useI18n();

  return <div>{t("some.translation.key")}</div>;
}

export default MyComponent;
*/
